type Props = {
  selected: string | null;
  onSelect: (value: string) => void;
};

const options = [
  "$5K - $15K",
  "$15K - $50K",
  "$50K - $100K",
  "$100K - $300K",
  "$300K - $500K",
  "$500K +",
];

const BudgetSelector: React.FC<Props> = ({ selected, onSelect  }) =>  {
  return (
    <div className=" bg-white p-4 border border-border grow min-h-[166px]">
      <label className="block text-primary-text text-subtitle-2 font-bold mb-3">
        Select your budget*
      </label>
      <div className="flex flex-wrap gap-2">
        {options.map((value) => (
          <button
            aria-label="arrow"
            key={value}
            type="button"
            className={`border text-subtitle-4 font-semibold transition-all duration-300 cursor-pointer ${
              selected === value
                ? "bg-[linear-gradient(96.18deg,_#0086E6_0%,_#0469B1_100%)] text-background px-[15px] py-[5px]"
                : "bg-[linear-gradient(96.18deg,_#ffffff_0%,_#ffffff_100%)] text-secondary-text border-border px-[10px] py-[5px] "
            }`}
            onClick={() => onSelect(value)}
          >
            {value}
          </button>
        ))}
      </div>
    </div>
  );
}
export default BudgetSelector;